import { Helmet } from "react-helmet-async";

const SITE_NAME = "Best Bizz Financial & Management Services N.V.";
const FALLBACK_ORIGIN = "https://www.bestbizz.biz";
const origin =
  typeof window !== "undefined" && window.location
    ? window.location.origin
    : FALLBACK_ORIGIN;

// Per-page SEO: title, description, canonical, Open Graph & Twitter cards.
export const Seo = ({
  title,
  description,
  path = "/",
  image = "/images/services.jpg",
}) => {
  const url = `${origin}${path}`;
  const fullTitle = title ? `${title} | Best Bizz Financial` : SITE_NAME;
  const img = image.startsWith("http") ? image : `${origin}${image}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;
